import React, { useState } from "react"
import Layout from "../components/layout/Layout"

const foundersData = [
	{
		id: "kiran",
		name: "Kiran Nu",
		role: "Founder, Chairman & MD (Strategic Mentor)",
		image: "images/about/Kiran.jpeg",
		delay: "0.1s",
		tags: [
			"15+ Yrs Experience",
			"Business Strategy",
			"Finance & Corporate Advisory",
			"Ecosystem Vision"
		],
		bio: [
			"Kiran Nu brings over 15 years of experience across <strong>business strategy, finance, corporate advisory, entrepreneurship and organisational development</strong>.",
			"His role at PROPLAY is centered around building the long-term institution behind the brand — shaping its vision, business model, partnerships, governance, financial strategy and expansion roadmap.",
			"His belief is that India's sporting opportunity extends far beyond professional competition. Sport has the potential to become an integral part of everyday life for millions of people if participation is made accessible, enjoyable, organised and continuous.",
			"Through PROPLAY, his focus is to build a scalable sporting ecosystem connecting arenas, academies, coaches, schools, residential communities, corporates, players and sporting organisations under a common platform.",
			"Rather than building PROPLAY merely as a chain of sporting facilities, his vision is to develop it into a lasting sports lifestyle brand and sports operating platform."
		]
	},
	{
		id: "karthik",
		name: "Karthik Y L",
		role: "Founder, Director & Chief Technology Officer",
		image: "images/about/KARTHIK.jpeg",
		delay: "0.2s",
		tags: [
			"Digital Backbone",
			"Platform Architecture",
			"Sports Player Experience",
			"Tech Innovation"
		],
		bio: [
			"Karthik Y L brings together two important strengths for PROPLAY — a strong technical background and extensive personal experience as a sports player.",
			"His understanding of technology combined with first-hand knowledge of the playing environment enables him to bridge the gap between sporting operations and technology.",
			"As CTO, his focus is on building the digital backbone of the PROPLAY ecosystem — connecting players, students, coaches, academies, arenas and partners through technology.",
			"The long-term objective is to create a seamless platform through which people can discover sports, book arenas, enroll into academies, track player development, manage coaching programmes and engage continuously with the PROPLAY sporting community."
		]
	},
	{
		id: "srivathsa",
		name: "Raju Srivathsa",
		role: "Founder, Director & Chief Executive Officer",
		image: "images/about/SRIVATHSA.jpeg",
		delay: "0.3s",
		tags: [
			"Super Division Club Owner",
			"Former Pro Cricketer",
			"KSCA-Certified Umpire",
			"Sporting Operations"
		],
		bio: [
			"Raju Srivathsa brings strong sporting and operational experience to PROPLAY.",
			"He is a co-owner of a Super Division football club, giving him direct exposure to competitive football, team development and the operational realities of running a sporting organisation.",
			"His sporting background also extends to cricket. He is a former professional cricket player and a KSCA-certified umpire, providing him with experience from both the player and officiating perspectives.",
			"As CEO, Raju Srivathsa leads the day-to-day business and sporting operations of PROPLAY, with particular focus on academy development, arena operations, sporting partnerships, coaches, teams and execution of the company's growth plans.",
			"His combination of sporting experience and operational leadership helps ensure that PROPLAY remains fundamentally a sports-led organisation."
		]
	},
	{
		id: "mohit",
		name: "Mohit Kumar A R",
		role: "Founder, Director & Chief Marketing & Development Officer",
		image: "images/about/MOHIT.jpeg",
		delay: "0.4s",
		tags: [
			"Brand & Marketing",
			"Strategic Partnerships",
			"Community Building",
			"Business Development"
		],
		bio: [
			"Mohit Kumar A R leads marketing, brand development, partnerships and business development for PROPLAY.",
			"His responsibility is to take the PROPLAY sporting ecosystem to a wider audience — building relationships with players, parents, academies, arena owners, schools, residential communities, corporates and sporting organisations.",
			"He plays an important role in identifying new markets and partnerships while developing the PROPLAY brand across its different sporting verticals.",
			"His mandate is not simply customer acquisition, but building a strong sporting community around PROPLAY and creating opportunities for the brand to continuously expand its footprint."
		]
	}
]

const teamLine1Data = [
	{
		id: "sowmya",
		name: "Sowmya P",
		role: "Head – Arena Operations",
		image: "images/about/Sowmya.jpeg",
		delay: "0.1s"
	},
	{
		id: "smitha",
		name: "Smitha M P",
		role: "Head - Sales",
		image: "images/about/Smitha.jpeg",
		delay: "0.2s"
	},
	{
		id: "ashwini",
		name: "Ashwini M",
		role: "Head - Human Resources",
		image: "images/about/Ashwini.jpeg",
		delay: "0.3s"
	},
	{
		id: "pallavi",
		name: "Pallavi Kashyap",
		role: "Head - Finance & Accounts",
		image: "images/about/Pallavi.jpeg",
		delay: "0.4s"
	},
	{
		id: "sujata",
		name: "Sujata Chavan",
		role: "Head - Vigilance & Risk Control",
		image: "images/about/Sujata.jpeg",
		delay: "0.5s"
	},
	{
		id: "goutam",
		name: "Goutam Suryavanshi",
		role: "Head - Business Development",
		image: "images/about/Goutam.jpeg",
		delay: "0.6s"
	}
]

const teamLine2Data = [
	{
		id: "megha",
		name: "Megha Achar",
		role: "Head - Event Management",
		image: "images/about/Megha.jpeg",
		delay: "0.1s"
	},
	{
		id: "sachin",
		name: "Sachin Manjunath",
		role: "Head - Social Media",
		image: "images/about/Sachin.jpeg",
		delay: "0.2s"
	},
	{
		id: "vaishnavi",
		name: "Vaishnavi",
		role: "Sales & Marketing Coordinator",
		image: "images/about/Vaishnavi.jpeg",
		delay: "0.3s"
	},
	{
		id: "bairoji",
		name: "S Bairoji Rao",
		role: "Coach",
		image: "images/about/Bairoji.jpeg",
		delay: "0.4s"
	},
	{
		id: "ujwal",
		name: "Ujwal Danappagol",
		role: "Coach",
		image: "images/about/Ujwal.jpeg",
		delay: "0.5s"
	},
	{
		id: "hemanth",
		name: "Hemanth Kumar G",
		role: "Coach",
		image: "images/about/Hemanth.jpeg",
		delay: "0.1s"
	}
]

const teamLine3Data = [
	{
		id: "sriram",
		name: "Sriram S B",
		role: "Coach",
		image: "images/about/Sriram.jpeg",
		delay: "0.2s"
	},
	{
		id: "vargees",
		name: "Vargees J G",
		role: "Assistant Coach",
		image: "images/about/Vargees.jpeg",
		delay: "0.3s"
	},
	{
		id: "naveen",
		name: "Naveen Kumar H R",
		role: "Concierge - Arena Operations",
		image: "images/about/Naveen.jpeg",
		delay: "0.4s"
	},
	{
		id: "swamy",
		name: "Swamy H R",
		role: "Concierge - Arena Operations",
		image: "images/about/Swamy.jpeg",
		delay: "0.5s"
	},
	{
		id: "sudeep",
		name: "Sudeep C",
		role: "Concierge - Arena Operations",
		image: "images/about/Sudeep.jpeg",
		delay: "0.6s"
	},
	{
		id: "lakshmamma",
		name: "Lakshmamma",
		role: "Arena Maintenance",
		image: "images/about/Lakshmamma.jpeg",
		delay: "0.1s"
	}
]


export default function About() {
	const [expanded, setExpanded] = useState({})

	const toggleReadMore = (id) => {
		setExpanded((prev) => ({
			...prev,
			[id]: !prev[id]
		}))
	}
	return (
		<Layout headerStyle={1} footerStyle={1}>
			<div className="proplay-about-page">
				{/* 1. HERO BANNER SECTION */}
				<section
					className="proplay-about-hero"
					style={{ backgroundImage: `url('images/about/hero_sports_bg.png')` }}
				>
					<div className="proplay-hero-overlay" />
					<div className="themeflat-container position-relative z-index-2 py-5">
						<div className="row align-items-center">
							<div className="col-lg-8 col-md-10">
								<div className="proplay-accent-line wow fadeInUp" data-wow-delay="0.1s" />
								<h1 className="proplay-hero-title wow fadeInUp" data-wow-delay="0.2s">
									MAKE SPORT <br />
									<span className="proplay-cyan-gradient">A WAY OF LIFE.</span>
								</h1>
								<p className="proplay-hero-subtitle wow fadeInUp" data-wow-delay="0.3s">
									Our purpose, philosophy and long-term direction.
								</p>
							</div>
						</div>
					</div>
				</section>

				{/* 2. OUR MISSION SECTION */}
				<section className="py-5" style={{ backgroundColor: "#040914" }} id="mission">
					<div className="themeflat-container py-4">
						{/* Top Section Badge & Title */}
						<div className="text-center mb-4 wow fadeInUp" data-wow-delay="0.1s">
							<div className="proplay-section-badge">
								<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<circle cx="12" cy="12" r="10" />
									<circle cx="12" cy="12" r="6" />
									<circle cx="12" cy="12" r="2" />
								</svg>
							</div>
							<div className="proplay-title-lines">
								<div className="proplay-line" />
								<h2 className="proplay-section-title">
									OUR <span className="proplay-cyan-gradient">MISSION</span>
								</h2>
								<div className="proplay-line" />
							</div>
						</div>

						{/* Mission Paragraph */}
						<p className="proplay-section-desc wow fadeInUp" data-wow-delay="0.2s">
							To make sport an enduring way of life by creating meaningful experiences that inspire participation, build lasting habits, and foster lifelong active living.
						</p>

						{/* Mission 5 Cards Grid */}
						<div className="proplay-5-grid mt-4">
							{/* Card 1 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.1s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
									</svg>
								</div>
								<div className="proplay-card-text">Experience first</div>
							</div>

							{/* Card 2 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.2s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
										<circle cx="9" cy="7" r="4" />
										<path d="M23 21v-2a4 4 0 0 0-3-3.87" />
										<path d="M16 3.13a4 4 0 0 1 0 7.75" />
									</svg>
								</div>
								<div className="proplay-card-text">Participation over spectatorship</div>
							</div>

							{/* Card 3 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.3s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<polyline points="23 4 23 10 17 10" />
										<polyline points="1 20 1 14 7 14" />
										<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
									</svg>
								</div>
								<div className="proplay-card-text">Consistency over one-time activity</div>
							</div>

							{/* Card 4 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.4s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
									</svg>
								</div>
								<div className="proplay-card-text">Sport for every stage of life</div>
							</div>

							{/* Card 5 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.5s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
										<line x1="4" y1="22" x2="4" y2="15" />
									</svg>
								</div>
								<div className="proplay-card-text">Beyond fitness</div>
							</div>
						</div>
					</div>
				</section>

				{/* 3. OUR VISION SECTION */}
				<section className="py-5" style={{ backgroundColor: "#060d1d" }} id="vision">
					<div className="themeflat-container py-4">
						{/* Top Section Badge & Title */}
						<div className="text-center mb-4 wow fadeInUp" data-wow-delay="0.1s">
							<div className="proplay-section-badge">
								<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
									<circle cx="12" cy="12" r="3" />
								</svg>
							</div>
							<div className="proplay-title-lines">
								<div className="proplay-line" />
								<h2 className="proplay-section-title">
									OUR <span className="proplay-cyan-gradient">VISION</span>
								</h2>
								<div className="proplay-line" />
							</div>
						</div>

						{/* Vision Paragraph */}
						<p className="proplay-section-desc wow fadeInUp" data-wow-delay="0.2s">
							To build a world where sport is accessible to everyone and becomes a natural and enduring part of everyday life.
						</p>

						{/* Vision 5 Cards Grid */}
						<div className="proplay-5-grid mt-4">
							{/* Card 1 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.1s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<circle cx="12" cy="12" r="10" />
										<line x1="2" y1="12" x2="22" y2="12" />
										<path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
									</svg>
								</div>
								<div className="proplay-card-text">Accessible sport</div>
							</div>

							{/* Card 2 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.2s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<circle cx="9" cy="7" r="4" />
										<path d="M12 15H6a4 4 0 0 0-4 4v2h14v-2a4 4 0 0 0-4-4z" />
										<circle cx="18" cy="11" r="3" />
										<path d="M22 21v-1a3 3 0 0 0-2-2.83" />
									</svg>
								</div>
								<div className="proplay-card-text">Every age</div>
							</div>

							{/* Card 3 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.3s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
										<line x1="9" y1="6" x2="9" y2="6.01" />
										<line x1="15" y1="6" x2="15" y2="6.01" />
										<line x1="9" y1="10" x2="9" y2="10.01" />
										<line x1="15" y1="10" x2="15" y2="10.01" />
										<line x1="9" y1="14" x2="9" y2="14.01" />
										<line x1="15" y1="14" x2="15" y2="14.01" />
										<line x1="9" y1="18" x2="15" y2="18" />
									</svg>
								</div>
								<div className="proplay-card-text">Every environment</div>
							</div>

							{/* Card 4 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.4s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<circle cx="18" cy="5" r="3" />
										<circle cx="6" cy="12" r="3" />
										<circle cx="18" cy="19" r="3" />
										<line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
										<line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
									</svg>
								</div>
								<div className="proplay-card-text">Connected ecosystem</div>
							</div>

							{/* Card 5 */}
							<div className="proplay-value-card wow fadeInUp" data-wow-delay="0.5s">
								<div className="proplay-card-icon">
									<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
										<path d="M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4zm0 0c2 2.67 4 4 6 4a4 4 0 1 0 0-8c-2 0-4 1.33-6 4z" />
									</svg>
								</div>
								<div className="proplay-card-text">Lifelong engagement</div>
							</div>
						</div>
					</div>
				</section>

				{/* 4. THE PROPLAY PHILOSOPHY SECTION */}
				<section className="proplay-philosophy-section" id="philosophy">
					<div className="themeflat-container">
						{/* Title */}
						<div className="text-center mb-4 wow fadeInUp" data-wow-delay="0.1s">
							<div className="proplay-title-lines">
								<div className="proplay-line" />
								<h2 className="proplay-section-title">
									THE PROPLAY <span className="proplay-cyan-gradient">PHILOSOPHY</span>
								</h2>
								<div className="proplay-line" />
							</div>
							<div className="d-flex justify-content-center mt-2">
								<div style={{ width: "60px", height: "3px", backgroundColor: "#00d4ff", borderRadius: "2px" }} />
							</div>
						</div>

						{/* Flowchart Diagram */}
						<div className="proplay-flow-diagram wow fadeInUp" data-wow-delay="0.2s">
							{/* Step 1 */}
							<div className="proplay-flow-step">
								<svg className="proplay-step-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
									<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
								</svg>
								<span className="proplay-step-title">EXPERIENCE</span>
							</div>

							<div className="proplay-flow-arrow">&rarr;</div>

							{/* Step 2 (Active/Glowing) */}
							<div className="proplay-flow-step active">
								<svg className="proplay-step-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
									<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
									<circle cx="9" cy="7" r="4" />
									<path d="M23 21v-2a4 4 0 0 0-3-3.87" />
									<path d="M16 3.13a4 4 0 0 1 0 7.75" />
								</svg>
								<span className="proplay-step-title">PARTICIPATION</span>
							</div>

							<div className="proplay-flow-arrow">&rarr;</div>

							{/* Step 3 */}
							<div className="proplay-flow-step">
								<svg className="proplay-step-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
									<polyline points="23 4 23 10 17 10" />
									<polyline points="1 20 1 14 7 14" />
									<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
								</svg>
								<span className="proplay-step-title">HABIT</span>
							</div>

							<div className="proplay-flow-arrow">&rarr;</div>

							{/* Step 4 */}
							<div className="proplay-flow-step">
								<svg className="proplay-step-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
									<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
								</svg>
								<span className="proplay-step-title">LIFESTYLE</span>
							</div>
						</div>

						{/* Philosophy Description */}
						<p className="proplay-section-desc mt-4 mb-0 wow fadeInUp" data-wow-delay="0.3s">
							Meaningful sporting experiences inspire participation, build habits, and ultimately transform sport into a way of life.
						</p>
					</div>
				</section>

				{/* 5. FOUNDER PARTNERS & DIRECTORS SECTION */}
				<section className="proplay-founders-section" id="founders">
					<div className="themeflat-container">
						{/* Top Section Badge & Title */}
						<div className="text-center mb-4 wow fadeInUp" data-wow-delay="0.1s">
							<div className="proplay-section-badge">
								<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
									<circle cx="9" cy="7" r="4" />
									<path d="M23 21v-2a4 4 0 0 0-3-3.87" />
									<path d="M16 3.13a4 4 0 0 1 0 7.75" />
								</svg>
							</div>
							<div className="proplay-title-lines">
								<div className="proplay-line" />
								<h2 className="proplay-section-title">
									FOUNDER PARTNERS &amp; <span className="proplay-cyan-gradient">DIRECTORS</span>
								</h2>
								<div className="proplay-line" />
							</div>
							<p className="proplay-section-desc mt-3 wow fadeInUp" data-wow-delay="0.2s">
								The leadership team driving the vision, technology, operations, and community ecosystem behind PROPLAY.
							</p>
						</div>

						{/* Founders Grid */}
						<div className="proplay-founders-grid">
							{foundersData.map((founder) => {
								const isExpanded = !!expanded[founder.id]
								return (
									<div
										key={founder.id}
										className="proplay-founder-card wow fadeInUp"
										data-wow-delay={founder.delay}
									>
										{/* Founder Photo */}
										<div className="proplay-founder-photo-wrap">
											<img
												src={founder.image}
												alt={founder.name}
												className="proplay-founder-photo"
											/>
										</div>

										{/* Name & Designation */}
										<div className="proplay-founder-info">
											<h3 className="proplay-founder-name">{founder.name}</h3>
											<span className="proplay-founder-role">{founder.role}</span>
										</div>

										{/* Read More / Read Less Toggle Button */}
										<button
											type="button"
											className="proplay-founder-readmore-btn"
											onClick={() => toggleReadMore(founder.id)}
											aria-expanded={isExpanded}
										>
											{isExpanded ? (
												<>
													Read Less
													<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
														<polyline points="18 15 12 9 6 15" />
													</svg>
												</>
											) : (
												<>
													Read More
													<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
														<polyline points="6 9 12 15 18 9" />
													</svg>
												</>
											)}
										</button>

										{/* Remaining content: visible only when expanded */}
										{isExpanded && (
											<div className="proplay-founder-details">
												<div className="proplay-founder-tags">
													{founder.tags.map((tag, idx) => (
														<span key={idx} className="proplay-founder-tag">{tag}</span>
													))}
												</div>
												<div className="proplay-founder-bio">
													{founder.bio.map((paragraph, pIdx) => (
														<p key={pIdx} dangerouslySetInnerHTML={{ __html: paragraph }} />
													))}
												</div>
											</div>
										)}
									</div>
								)
							})}
						</div>

						{/* Team Row 1: Sowmya P > Smitha M P > Ashwini M > Pallavi Kashyap > Sujata Chavan > Goutam Suryavanshi */}
						<div className="proplay-team-row-6">
							{teamLine1Data.map((member) => (
								<div
									key={member.id}
									className="proplay-team-card wow fadeInUp"
									data-wow-delay={member.delay}
								>
									<div className="proplay-team-photo-wrap">
										<img
											src={member.image}
											alt={member.name}
											className="proplay-team-photo"
										/>
									</div>
									<div className="proplay-team-info">
										<h3 className="proplay-team-name">{member.name}</h3>
										<span className="proplay-team-role">{member.role}</span>
									</div>
								</div>
							))}
						</div>

						{/* Team Row 2: Megha Achar > Sachin Manjunath > Vaishnavi > S Bairoji Rao > Ujwal Danappagol > Hemanth Kumar G */}
						<div className="proplay-team-row-6">
							{teamLine2Data.map((member) => (
								<div
									key={member.id}
									className="proplay-team-card wow fadeInUp"
									data-wow-delay={member.delay}
								>
									<div className="proplay-team-photo-wrap">
										<img
											src={member.image}
											alt={member.name}
											className="proplay-team-photo"
										/>
									</div>
									<div className="proplay-team-info">
										<h3 className="proplay-team-name">{member.name}</h3>
										<span className="proplay-team-role">{member.role}</span>
									</div>
								</div>
							))}
						</div>

						{/* Team Row 3: Sriram S B > Vargees J G > Naveen Kumar H R > Swamy H R > Sudeep C > Lakshmamma */}
						<div className="proplay-team-row-6">
							{teamLine3Data.map((member) => (
								<div
									key={member.id}
									className="proplay-team-card wow fadeInUp"
									data-wow-delay={member.delay}
								>
									<div className="proplay-team-photo-wrap">
										<img
											src={member.image}
											alt={member.name}
											className="proplay-team-photo"
										/>
									</div>
									<div className="proplay-team-info">
										<h3 className="proplay-team-name">{member.name}</h3>
										<span className="proplay-team-role">{member.role}</span>
									</div>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* 6. JOIN PROPLAY CTA BANNER */}
				<section
					className="proplay-cta-section"
					style={{ backgroundImage: `url('images/about/join_proplay_bg.png')` }}
				>
					<div className="proplay-cta-overlay" />
					<div className="themeflat-container position-relative z-index-2">
						<div className="row align-items-center">
							<div className="col-lg-8">
								<h2 className="proplay-cta-title wow fadeInUp" data-wow-delay="0.1s">
									Join <span className="proplay-cyan-gradient">PROPLAY.</span>
								</h2>
								<h3 className="proplay-cta-sub wow fadeInUp" data-wow-delay="0.2s">
									Play. Learn. Compete. Belong.
								</h3>
								<div className="d-flex flex-wrap gap-3 wow fadeInUp" data-wow-delay="0.3s">
									<a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" className="proplay-btn-cyan">
										FIND YOUR SPORT &rarr;
									</a>
									<a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" className="proplay-btn-outline">
										PARTNER WITH PROPLAY &rarr;
									</a>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</Layout>
	)
}